
export const styles = () => ({
  image: {
    height: 60,
    width: 60,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
  unavailable: {
    color: "red",
  },
  colorprimary:{
    width: "14%",
    height: "40px",

  },

  
  formdev:{
    padding: "10px 22px 0 15px",

  },
  allnameflex:{
    display:"flex",
    marginBottom:"10px",
  },
  allnameflex1:{
    display:"flex",
    marginTop:"18px",
    marginBottom:"18px",
  },
  logo1divs:{
    display:"flex",
    width:"50%",
  },
  logo1lable:{
    marginRight:"10px",
  },
  inputlogo1:{
marginTop:"20px",
  },
  labelflex:{
    width:"50%",
  },
    inputboxis:{
    width:"96%",
    marginTop: "3px",
    height: "40px",
    fontSize: "14px",
    paddingLeft: "10px",
    borderRadius: "8px",
    border: "1px solid #d9d9d4",
  },
    inputboxis1:{
    width:"98%",
    marginTop: "3px",
    height: "40px",
    fontSize: "14px",
    paddingLeft: "10px",
    borderRadius: "8px",
    border: "1px solid #d9d9d4",
  },
  labelcolor:{
    color:"rgba(0, 0, 0, 0.87)",
    fontSize:"16px",
  },
  primaryinputcolor:{
  height: "40px",
    width: "80%",
    paddingLeft: "10px",
    border: "1px solid #d9d9d9",
    borderRadius: "8px",
    marginRight: '10px',
  },
  btnuploads:{
  width: "150px",
    height: "40px",
    margin: "10px 10px",
    fontSize: "18px",
    lineHeight: "10px",
  },
  primarysec:{
    display:"flex",
  },
  primary:{
    width:"50%",
  },
  secondary:{
    width:"50%",
  },
    updatebtn:{
    display:"flex",
    justifyContent: "space-between",
    padding:" 6px 25px 0 0px",
    marginBottom:"10px",
  },
  spanlink:{
    marginTop:"3px",
  },
 });



// WEBPACK FOOTER //
// ./src/features/director/pages/editSchoolUser/styles.ts